import angular from 'angular';
import itemListComponent from './item-list.component';

export default angular.module('components.common.item-list', [])
  .component('itemList', itemListComponent)
  .name;



// WEBPACK FOOTER //
// ./components/app/common/item-list/item-list.module.js